import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'seats';
export const route = 'seats/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/SeatsPage')));